import { createColumnHelper } from "@tanstack/react-table";
import {
  IPendingBarcodes,
  IPendingBarcodesTanoti,
} from "../../interfaces/app_types";
import { getDateFromString } from "../funcs/time";
import { downloadBarcode } from "../../api/inout";

const columnHelper = createColumnHelper<IPendingBarcodes>();

export const pendingBarcodesReportCols = (
  onHistoryClick: (barcodeValue: string) => void
) => [
  columnHelper.accessor((row) => row?.barcode_id, {
    header: "ID",
    enableColumnFilter: false,
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.barcode_value, {
    header: "Barcode",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.barcode_value, {
    id: "Download",
    enableColumnFilter: false,
    cell: (info) =>
      info.getValue() !== "" ? (
        <button
          className="btn btn-outline-none text-primary p-0"
          onClick={async () => await downloadBarcode(info.getValue())}
        >
          <i className="bi bi-upc-scan"></i>
        </button>
      ) : (
        "NA"
      ),
  }),
  columnHelper.accessor((row) => row?.part_id, {
    header: "Part ID",
    enableColumnFilter: false,
    cell: (info) => String(info.getValue()),
  }),
  columnHelper.accessor((row) => row?.part_name, {
    header: "Part Name",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.drawing, {
    header: "Drawing",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.drawing_link, {
    header: "Drawing Link",
    enableColumnFilter: false,
    cell: (info) =>
      info.getValue() !== "" ? (
        <a href={info.getValue()} target="_blank" rel="noreferrer">
          <i className="bi bi-box-arrow-up-right"></i>
        </a>
      ) : (
        "NA"
      ),
  }),
  columnHelper.accessor((row) => row?.available_qty, {
    header: "Pending Qty",
    enableColumnFilter: false,
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.barcode_value, {
    id: "History",
    header: "History",
    enableColumnFilter: false,
    cell: (info) => (
      <button
        className="styled-btn--dark"
        data-bs-toggle="modal"
        data-bs-target="#reportHistoryModal"
        onClick={() => onHistoryClick(info.getValue())}
        key={info.getValue()}
      >
        View
      </button>
    ),
  }),
  columnHelper.accessor((row) => row?.total_qty, {
    header: "Total Qty",
    enableColumnFilter: false,
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.updated_at, {
    header: "Last Updated",
    enableColumnFilter: false,
    cell: (info) => getDateFromString(info.getValue()),
  }),
];

const tanotiColumnHelper = createColumnHelper<IPendingBarcodesTanoti>();

export const pendingBarcodesTanotiReportCols = (
  onHistoryClick: (barcodeValue: string) => void
) => [
  tanotiColumnHelper.accessor((row) => row?.barcode_id, {
    header: "ID",
    enableColumnFilter: false,
    cell: (info) => info.getValue(),
  }),
  tanotiColumnHelper.accessor((row) => row?.sku_code, {
    id: "SKU Code",
    cell: (info) => info.getValue(),
  }),
  tanotiColumnHelper.accessor((row) => row?.part_name, {
    id: "Name",
    filterFn: "includesString",
    cell: (info) => info.getValue(),
  }),
  tanotiColumnHelper.accessor((row) => row?.variant, {
    id: "Variant",
    filterFn: "includesString",
    cell: (info) => info.getValue(),
  }),
  tanotiColumnHelper.accessor((row) => row?.size, {
    id: "Size",
    filterFn: "includesString",
    cell: (info) => info.getValue(),
  }),
  tanotiColumnHelper.accessor((row) => row?.barcode_value, {
    header: "Barcode",
    cell: (info) => info.getValue(),
  }),
  tanotiColumnHelper.accessor((row) => row?.barcode_value, {
    id: "Download",
    enableColumnFilter: false,
    cell: (info) =>
      info.getValue() !== "" ? (
        <button
          className="btn btn-outline-none text-primary p-0"
          onClick={async () => await downloadBarcode(info.getValue())}
        >
          <i className="bi bi-upc-scan"></i>
        </button>
      ) : (
        "NA"
      ),
  }),
  tanotiColumnHelper.accessor((row) => row?.available_qty, {
    header: "Pending Qty",
    enableColumnFilter: false,
    cell: (info) => info.getValue(),
  }),
  tanotiColumnHelper.accessor((row) => row?.total_qty, {
    header: "Total Qty",
    enableColumnFilter: false,
    cell: (info) => info.getValue(),
  }),
  tanotiColumnHelper.accessor((row) => row?.barcode_value, {
    id: "History",
    header: "History",
    enableColumnFilter: false,
    cell: (info) => (
      <button
        className="styled-btn--dark"
        data-bs-toggle="modal"
        data-bs-target="#reportHistoryModal"
        onClick={() => onHistoryClick(info.getValue())}
        key={info.getValue()}
      >
        View
      </button>
    ),
  }),
  tanotiColumnHelper.accessor((row) => row?.updated_at, {
    header: "Last Updated",
    enableColumnFilter: false,
    cell: (info) => getDateFromString(info.getValue()),
  }),
];
